import { useState } from 'react';

const tabs = [
  { key: 'company', label: 'Firma Bilgileri', icon: 'ri-building-line' },
  { key: 'templates', label: 'Mesaj Şablonları', icon: 'ri-chat-settings-line' },
  { key: 'users', label: 'Kullanıcılar', icon: 'ri-user-settings-line' },
  { key: 'cargo', label: 'Kargo Firmaları', icon: 'ri-truck-line' },
  { key: 'stages', label: 'Üretim Aşamaları', icon: 'ri-tools-line' },
  { key: 'payment', label: 'Ödeme Tipleri', icon: 'ri-bank-card-line' },
];

const userRoles = [
  { role: 'Yönetici', permissions: 'Tüm yetkiler', color: 'bg-gold-500' },
  { role: 'Üretim Personeli', permissions: 'Üretim takibi, sipariş görüntüleme', color: 'bg-status-purple' },
  { role: 'Kargo Sorumlusu', permissions: 'Kargo takibi, kargo durumu güncelleme', color: 'bg-status-sky' },
  { role: 'Muhasebe / Cari', permissions: 'Cari takip, ödeme durumu güncelleme', color: 'bg-status-green' },
  { role: 'Sadece Görüntüleme', permissions: 'Tüm ekranları görüntüleme, değişiklik yapamaz', color: 'bg-status-gray' },
];

const mockUsers = [
  { id: 1, name: 'Ali Usta', role: 'Yönetici', email: 'ali@tablocum11.com', active: true },
  { id: 2, name: 'Mehmet Usta', role: 'Üretim Personeli', email: 'mehmet@tablocum11.com', active: true },
  { id: 3, name: 'Ayşe Hanım', role: 'Kargo Sorumlusu', email: 'ayse@tablocum11.com', active: true },
  { id: 4, name: 'Fatma Hanım', role: 'Muhasebe / Cari', email: 'fatma@tablocum11.com', active: true },
  { id: 5, name: 'Stajyer', role: 'Sadece Görüntüleme', email: 'stajyer@tablocum11.com', active: false },
];

const messageTemplateEdits = [
  { key: 'daily', label: 'Günlük Bilgilendirme', template: 'Merhaba {{musteri_adi}}, Tablocum.11 siparişinizin güncel durumu: {{siparis_durumu}}. Ürününüz şu anda {{uretim_asamasi}} aşamasındadır. Her aşama tamamlandığında sizi bilgilendireceğiz.' },
  { key: 'drawing', label: 'Çizim Aşaması', template: 'Merhaba {{musteri_adi}}, siparişiniz için çizim aşamasına geçilmiştir. Tasarım hazırlandığında onayınız için size iletilecektir.' },
  { key: 'cargo', label: 'Kargo Mesajı', template: 'Merhaba {{musteri_adi}}, Tablocum.11 siparişiniz kargoya verilmiştir.\nKargo firması: {{kargo_firmasi}}\nTakip numarası: {{takip_no}}\nÜrün teslim sürecinizi bu takip numarası ile kontrol edebilirsiniz.' },
  { key: 'thanks', label: 'Teslimat Sonrası Teşekkür', template: 'Merhaba {{musteri_adi}}, Tablocum.11 siparişinizin size ulaşmış olmasını umuyoruz. Güzel günlerde kullanmanız dileğiyle. Memnuniyetinizi bizimle paylaşmanız bizi mutlu eder.' },
];

const cargoCompanies = ['MNG Kargo', 'Aras Kargo', 'Yurtiçi Kargo', 'PTT Kargo', 'Sürat Kargo'];

const productionStages = [
  'Yeni Sipariş', 'Çizim Aşaması', 'Çizim Onayı Bekliyor', 'Kesim Aşaması',
  'Aydınlatma / Montaj', 'Test Aşaması', 'Paketleme', 'Kargoya Hazır',
];

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState('company');
  const [templates, setTemplates] = useState(messageTemplateEdits);

  return (
    <div>
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-xl md:text-2xl font-bold text-stone-900">Ayarlar</h2>
        <p className="text-sm text-stone-500 mt-0.5">Sistem yapılandırması ve yönetimi</p>
      </div>

      {/* Tabs */}
      <div className="flex items-center gap-1 bg-stone-100 rounded-xl p-1 mb-6 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
              activeTab === tab.key
                ? 'bg-white text-stone-800 shadow-sm'
                : 'text-stone-500 hover:text-stone-700'
            }`}
          >
            <i className={`${tab.icon} text-base`} />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="bg-white rounded-xl border border-stone-200/80 p-6">
        {/* Company Info */}
        {activeTab === 'company' && (
          <div className="max-w-2xl space-y-5">
            <h4 className="text-sm font-semibold text-stone-800">Firma Bilgileri</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="text-xs text-stone-500 block mb-1">Firma Adı</label>
                <input type="text" defaultValue="Tablocum.11" className="w-full px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-sm text-stone-800 focus:outline-none focus:border-gold-400" />
              </div>
              <div>
                <label className="text-xs text-stone-500 block mb-1">WhatsApp Numarası</label>
                <input type="text" defaultValue="90 555 123 4567" className="w-full px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-sm text-stone-800 focus:outline-none focus:border-gold-400" />
              </div>
              <div>
                <label className="text-xs text-stone-500 block mb-1">E-posta</label>
                <input type="email" defaultValue="info@tablocum11.com" className="w-full px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-sm text-stone-800 focus:outline-none focus:border-gold-400" />
              </div>
              <div>
                <label className="text-xs text-stone-500 block mb-1">Telefon</label>
                <input type="text" defaultValue="0 555 123 4567" className="w-full px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-sm text-stone-800 focus:outline-none focus:border-gold-400" />
              </div>
              <div className="sm:col-span-2">
                <label className="text-xs text-stone-500 block mb-1">Adres</label>
                <textarea rows={2} defaultValue="Örnek Mah. Sanayi Cad. No:11, İstanbul" className="w-full px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-sm text-stone-800 focus:outline-none focus:border-gold-400 resize-none" />
              </div>
            </div>
            <button className="px-4 py-2 bg-gold-500 text-white text-sm font-medium rounded-lg hover:bg-gold-600 transition-colors cursor-pointer whitespace-nowrap">
              Kaydet
            </button>
          </div>
        )}

        {/* Message Templates */}
        {activeTab === 'templates' && (
          <div className="space-y-5">
            <div className="flex items-center justify-between">
              <h4 className="text-sm font-semibold text-stone-800">Mesaj Şablonları</h4>
              <p className="text-xs text-stone-400">Dinamik alanlar: {'{{musteri_adi}} {{siparis_no}} {{siparis_durumu}} {{uretim_asamasi}}'}</p>
            </div>
            <div className="space-y-4">
              {templates.map((tpl, idx) => (
                <div key={tpl.key}>
                  <label className="text-xs font-medium text-stone-600 block mb-1.5">{tpl.label}</label>
                  <textarea
                    rows={3}
                    value={tpl.template}
                    onChange={(e) => {
                      const newTemplates = [...templates];
                      newTemplates[idx] = { ...tpl, template: e.target.value };
                      setTemplates(newTemplates);
                    }}
                    className="w-full px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-sm text-stone-800 focus:outline-none focus:border-gold-400 resize-none"
                  />
                </div>
              ))}
            </div>
            <button className="px-4 py-2 bg-gold-500 text-white text-sm font-medium rounded-lg hover:bg-gold-600 transition-colors cursor-pointer whitespace-nowrap">
              Şablonları Kaydet
            </button>
          </div>
        )}

        {/* Users */}
        {activeTab === 'users' && (
          <div className="space-y-5">
            <div className="flex items-center justify-between">
              <h4 className="text-sm font-semibold text-stone-800">Kullanıcılar</h4>
              <button className="px-3 py-1.5 bg-gold-500 text-white text-xs font-medium rounded-lg hover:bg-gold-600 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-add-line mr-1" />Kullanıcı Ekle
              </button>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-stone-100">
                    <th className="text-left text-xs font-semibold text-stone-500 px-3 py-2">Kullanıcı</th>
                    <th className="text-left text-xs font-semibold text-stone-500 px-3 py-2">E-posta</th>
                    <th className="text-left text-xs font-semibold text-stone-500 px-3 py-2">Rol</th>
                    <th className="text-center text-xs font-semibold text-stone-500 px-3 py-2">Durum</th>
                    <th className="text-center text-xs font-semibold text-stone-500 px-3 py-2">Aksiyon</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-stone-50">
                  {mockUsers.map((user) => (
                    <tr key={user.id} className="hover:bg-stone-50/50">
                      <td className="px-3 py-3">
                        <span className="text-sm font-medium text-stone-800">{user.name}</span>
                      </td>
                      <td className="px-3 py-3">
                        <span className="text-xs text-stone-500">{user.email}</span>
                      </td>
                      <td className="px-3 py-3">
                        <span className="text-xs text-stone-600">{user.role}</span>
                      </td>
                      <td className="px-3 py-3 text-center">
                        <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${
                          user.active ? 'bg-status-green/10 text-status-green' : 'bg-status-gray/10 text-status-gray'
                        }`}>
                          {user.active ? 'Aktif' : 'Pasif'}
                        </span>
                      </td>
                      <td className="px-3 py-3">
                        <div className="flex items-center justify-center gap-1">
                          <button className="w-7 h-7 flex items-center justify-center rounded-md bg-stone-100 text-stone-500 hover:bg-stone-200 transition-colors cursor-pointer" title="Düzenle">
                            <i className="ri-edit-line text-sm" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Roles */}
            <div className="pt-4 border-t border-stone-100">
              <h5 className="text-xs font-semibold text-stone-500 uppercase tracking-wider mb-3">Roller ve Yetkiler</h5>
              <div className="space-y-2">
                {userRoles.map((role) => (
                  <div key={role.role} className="flex items-center gap-3 p-3 bg-stone-50 rounded-lg">
                    <div className={`w-2.5 h-2.5 rounded-full ${role.color} flex-shrink-0`} />
                    <div className="flex-1 min-w-0">
                      <span className="text-sm font-medium text-stone-800">{role.role}</span>
                      <p className="text-xs text-stone-400">{role.permissions}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Cargo Companies */}
        {activeTab === 'cargo' && (
          <div className="max-w-md space-y-4">
            <h4 className="text-sm font-semibold text-stone-800">Kargo Firmaları</h4>
            <div className="space-y-2">
              {cargoCompanies.map((company, idx) => (
                <div key={idx} className="flex items-center gap-3 p-3 bg-stone-50 rounded-lg">
                  <i className="ri-truck-line text-stone-400" />
                  <span className="text-sm text-stone-700 flex-1">{company}</span>
                  <div className="flex items-center gap-1">
                    <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-stone-200 text-stone-400 hover:text-stone-600 transition-colors cursor-pointer">
                      <i className="ri-edit-line text-sm" />
                    </button>
                    <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-red-50 text-stone-400 hover:text-red-500 transition-colors cursor-pointer">
                      <i className="ri-delete-bin-line text-sm" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <button className="flex items-center gap-1.5 px-3 py-2 text-sm text-gold-600 hover:text-gold-700 font-medium cursor-pointer">
              <i className="ri-add-line" /> Yeni Kargo Firması Ekle
            </button>
          </div>
        )}

        {/* Production Stages */}
        {activeTab === 'stages' && (
          <div className="max-w-md space-y-4">
            <h4 className="text-sm font-semibold text-stone-800">Üretim Aşamaları</h4>
            <div className="space-y-1">
              {productionStages.map((stage, idx) => (
                <div key={idx} className="flex items-center gap-3 p-3 bg-stone-50 rounded-lg">
                  <span className="w-6 h-6 rounded-full bg-gold-500/10 text-gold-600 flex items-center justify-center text-xs font-bold flex-shrink-0">{idx + 1}</span>
                  <span className="text-sm text-stone-700 flex-1">{stage}</span>
                  <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-stone-200 text-stone-400 hover:text-stone-600 transition-colors cursor-pointer">
                    <i className="ri-edit-line text-sm" />
                  </button>
                </div>
              ))}
            </div>
            <button className="flex items-center gap-1.5 px-3 py-2 text-sm text-gold-600 hover:text-gold-700 font-medium cursor-pointer">
              <i className="ri-add-line" /> Yeni Aşama Ekle
            </button>
          </div>
        )}

        {/* Payment Types */}
        {activeTab === 'payment' && (
          <div className="max-w-md space-y-4">
            <h4 className="text-sm font-semibold text-stone-800">Ödeme Tipleri</h4>
            <div className="space-y-2">
              {[
                { name: 'Kapıda Ödeme', icon: 'ri-money-dollar-circle-line', active: true },
                { name: 'Havale / EFT', icon: 'ri-bank-line', active: true },
                { name: 'Kredi Kartı', icon: 'ri-bank-card-line', active: true },
              ].map((pt, idx) => (
                <div key={idx} className="flex items-center gap-3 p-3 bg-stone-50 rounded-lg">
                  <i className={`${pt.icon} text-stone-400`} />
                  <span className="text-sm text-stone-700 flex-1">{pt.name}</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" defaultChecked={pt.active} className="sr-only peer" />
                    <div className="w-9 h-5 bg-stone-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-gold-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-gold-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all" />
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}